enum ArticleNarrationTypes {
    HUMAN = 0,
    AI_SILVER = 1,
    AI_GOLD = 2,
}

export default ArticleNarrationTypes;
